import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { MechanicValidatorKnight } from '@colonist/game-mechanic-validators';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { useMapValidator } from './useMapValidator.ts';
export const useKnightValidator = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const mechanicKnightState = useGameStore((state)=>state.gameState.mechanicKnightState);
    if (mechanicKnightState == undefined) return undefined;
    return useMemo(()=>{
        const validator = new MechanicValidatorKnight(playerValidators, mapValidator, mechanicKnightState);
        return validator;
    }, [
        playerValidators,
        mapValidator,
        mechanicKnightState
    ]);
};
